// Copyright (c) 2016 Deere & Company

import './machine-status-update-results.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import StatusChange, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/status-change';
import Attachments from '../../../tcsm/shared/components/attachments';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../shared/components/labeled-string';
import LawEnforcementInfo from '../../../tcsm/wip/components/machine-status-updates/law-enforcement-info';
import {Link} from 'react-router';
import PipStatus from '../../shared/components/pip-status';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../../../shared/services/build-dealer';
import {translatedMachinePutBackStatus} from '../../../shared/services/machine-put-back-status';

class MachineStatusUpdateResult extends Component {

    state = {
        showConfirmDelete: false
    };

    handleOpenConfirmationModal = () => {

        document.body.classList.add('warranty-modal-is-open');
        this.setState({showConfirmDelete: true});

    };

    handleCloseConfirmationModal = () => {

        document.body.classList.remove('warranty-modal-is-open');
        this.setState({showConfirmDelete: false});

    };

    handleDeleteClick = () => {

        this.props.deleteAction(this.props.statusChangeObject.id);
        document.body.classList.remove('warranty-modal-is-open');
        this.setState({showConfirmDelete: false});

    };

    render() {

        return (
            <section className='machine-status-update-result'>
                <section className='machine-status-update-result-body'>
                    <div className='product-header'>
                        <Link
                            className='product-title'
                            rel='noopener noreferrer'
                            target='_blank'
                            to={`/products/${this.props.statusChangeObject.product.pin}`}
                        >
                            {this.props.statusChangeObject.product.pin}
                        </Link>
                        <span className='machine-new-status'>{this.props.statusChangeObject.newStatus.value}</span>
                        <span className='pip-status-container'>
                            {this.props.statusChangeObject.product.pipIndicator.status &&
                            <PipStatus
                                pin={this.props.statusChangeObject.product.pin}
                                pipIndicator={this.props.statusChangeObject.product.pipIndicator}
                            />
                                        }
                        </span>
                    </div>
                    <div className='machine-status-info'>
                        <div className='row'>
                            <LabeledString
                                className='dealer-location'
                                data={buildDealer(this.props.statusChangeObject.product.dealer)}
                                label='DEALER_LOCATION'
                            />
                        </div>
                        <div className='row'>
                            <LabeledString
                                className='model'
                                data={this.props.statusChangeObject.product.model}
                                label='MODEL'
                            />
                            <LabeledString
                                className='customer'
                                data={this.props.statusChangeObject.product.customerSummary.displayName}
                                label='CUSTOMER'
                            />
                        </div>
                        <div className='row'>
                            <LabeledString
                                className='created-by'
                                data={this.props.statusChangeObject.createdBy.buildUserName()}
                                label='CREATED_BY'
                            />
                            <LabeledString
                                className='created-on'
                                data={buildDate(this.props.statusChangeObject.createdDate)}
                                label='CREATED_ON'
                            />
                        </div>
                        <div className='row'>
                            <LabeledString
                                className='dealer-comments'
                                data={this.props.statusChangeObject.comments}
                                label='DEALER_COMMENTS'
                            />
                        </div>
                        {(this.props.statusChangeObject.newStatus.key === 'EOOS' || this.props.statusChangeObject.newStatus.key === 'DMGD') &&
                        <div>
                            <div className='row'>
                                <LabeledString
                                    className='damage-event-date'
                                    data={buildDate(this.props.statusChangeObject.damageEventDate)}
                                    label='DATE_OF_EVENT_CAUSING_DAMAGE'
                                />
                                <LabeledString
                                    className='machine-put-back'
                                    data={translatedMachinePutBackStatus(this.props.statusChangeObject.machinePutBack)}
                                    label='CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE'
                                />
                            </div>
                            <div className='row'>
                                <LabeledString
                                    className='description-of-damage'
                                    data={this.props.statusChangeObject.damageDesc}
                                    label='DESCRIPTION_OF_DAMAGE'
                                />
                                <LabeledString
                                    className='description-causing-damage'
                                    data={this.props.statusChangeObject.damageEventDesc}
                                    label='DESCRIPTION_OF_EVENT_CAUSING_DAMAGE'
                                />
                            </div>
                        </div>
                            }
                        {this.props.statusChangeObject.newStatus.key === 'LCUK' &&
                        <div className='row'>
                            <LabeledString
                                className='last-contact-date'
                                data={buildDate(this.props.statusChangeObject.lastContactDetails.lastContactDate)}
                                label='DATE_OF_LAST_PERSONAL_CONTACT'
                            />
                            <LabeledString
                                className='certified-letter-date'
                                data={buildDate(this.props.statusChangeObject.lastContactDetails.letterSentDate)}
                                label='DATE_OF_CERTIFIED_LETTER'
                            />
                        </div>
                            }
                        <div className='row'>
                            {this.props.statusChangeObject.newStatus.key === 'STL1' &&
                            <LawEnforcementInfo lawEnforcementInfo={this.props.statusChangeObject.lawEnforcementDetails}/>
                                }
                            <Attachments files={this.props.statusChangeObject.file}/>
                        </div>
                    </div>
                </section>
                <footer>
                    <section className='button-group'>
                        <button onClick={this.handleOpenConfirmationModal}>
                            <FormattedMessage id='DELETE'/>
                        </button>
                        <Link
                            className='primary'
                            to={`/products/status-change-request/${encodeURIComponent(this.props.statusChangeObject.product.pin)}?statusChangeId=${this.props.statusChangeObject.id}`}
                        >
                            <FormattedMessage id='EDIT'/>
                        </Link>
                    </section>
                </footer>
                <ConfirmationModal
                    confirmMessage='CONFIRM_DELETE_MACHINE_STATUS_UPDATE'
                    isOpen={this.state.showConfirmDelete}
                    onClose={this.handleCloseConfirmationModal}
                    onConfirm={this.handleDeleteClick}
                    title='DELETE_MACHINE_STATUS_UPDATE'
                />
            </section>
        );

    }
}

MachineStatusUpdateResult.displayName = 'MachineStatusUpdateResult';
MachineStatusUpdateResult.propTypes = {
    deleteAction: PropTypes.func.isRequired,
    statusChangeObject: PropTypes.instanceOf(StatusChange)
};
MachineStatusUpdateResult.defaultProps = {
    statusChangeObject: getDefaultState()
};

export default MachineStatusUpdateResult;



// WEBPACK FOOTER //
// ./src/product/machine-status-update/components/machine-status-update-results.js